module.exports = __webpack_public_path__ + "img/download-test-1.8b1cee53.png";